<template>
  <router-view v-if="this.$route.path!=='/accountManage/staffManage' && this.$route.path!=='/qianchuan/account/staff'" :departmentList.sync="departmentList" :editEmployeeId.sync="editEmployeeId" :roleList.sync="roleList" :activeDepartmentId.sync="activeDepartmentId"></router-view>
  <div v-else class="staffManage">
   <div class="project_null" v-if="nullShow">
      <img class="" src="@/assets/img/project_manage_null.png" alt="">
      <div class="project_title">欢迎使用道有道智投RPA</div>
      <div  class="project_sub">暂未添加员工，你可通过创建员工账号进行权限角色管理</div>
      <el-button type="primary" round>创建员工</el-button>
    </div>
    <div v-else>
      <!-- 新增/编辑部门 -->
      <div class="operateDepartment">
        <el-dialog :title="departmentPopupTitle" :visible.sync="operateDepartmentVisible" :close-on-click-modal="false">
          <el-form ref="operateDepartmentForm" :model="operateDepartmentForm" :rules="operateDepartmentRules" label-width="80px">
            <el-form-item label="部门名称" prop="name">
              <el-input v-model="operateDepartmentForm.name" placeholder="请输入部门名称" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="所属团队" prop="team">
              <el-select v-model="operateDepartmentForm.team" placeholder="请选择所属团队">
                <el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="btn">
              <el-button size="small" @click="operateDepartmentVisible=false">取 消</el-button>
              <el-button size="small" type="primary" @click="operateDepartmenSubmit('operateDepartmentForm')">确 定</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <!-- 重置密码 -->
      <div class="resetPassword">
        <el-dialog title="重置密码" :visible.sync="resetPasswordVisible" :close-on-click-modal="false">
          <el-form ref="resetPasswordForm" :model="resetPasswordForm" :rules="resetPasswordRules">
            <el-form-item label="" prop="password">
              <el-input v-model="resetPasswordForm.password" show-password maxlength="16" placeholder="新密码"></el-input>
            </el-form-item>
            <el-form-item label="" prop="repeatPassword">
              <el-input v-model="resetPasswordForm.repeatPassword" show-password maxlength="16" placeholder="确认密码"></el-input>
            </el-form-item>
            <el-form-item class="btn">
              <el-button size="small" @click="resetPasswordVisible=false">取 消</el-button>
              <el-button size="small" type="primary" @click="resetPasswordSubmit('resetPasswordForm')">确 定</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <!-- 查看投放账户 -->
      <div class="viewDeliveryAccount">
        <el-dialog title="查看投放账户" :visible.sync="viewAccountVisible" :close-on-click-modal="false">
          <el-form>
            <el-form-item label="">
              <div class="employeeInfo">
                <span>部门：{{viewDeliveryAccount.departmentName}}</span>
                <span>员工姓名：{{viewDeliveryAccount.employeeName}}</span>
              </div>
              <el-table :data="viewDeliveryAccount.list" border stripe height="358">
                <el-table-column prop="agentAccountName" label="广告投放账户"></el-table-column>
                <el-table-column prop="agentAccountId" label="账户ID"></el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item class="btn">
              <el-button size="small" @click="viewAccountVisible=false">取 消</el-button>
              <el-button size="small" type="primary" @click="viewAccountVisible=false">确 定</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <!-- 员工管理列表 -->
      <div class="staffCon">
        <div class="departmentList">
          <div class="title clearfix">
            <p>部门</p>
            <i class="iconfont icon-tianjia-copy" @click="operateDepartment('add')"></i>
          </div>
          <div class="list">
            <div class="item" v-for="item in departmentList" :key="item.id" :class="{'active':activeDepartmentId==item.id}" @click="changeDepartmentActive(item.id,item.departmentName)">
              <p class="clearfix">
                <span>{{item.departmentName}}</span>
                <i v-if="item.departmentName!=='全部'" class="iconfont icon-edit" @click="operateDepartment('edit',item)"></i>
              </p>
              <div class="num" v-if="item.employeeAmount>0">{{item.employeeAmount}}</div>
            </div>
          </div>
        </div>
        <div class="staffList">
          <div class="top">
            <div class="page-title">员工管理</div>
            <div class="btn clearfix">
              <router-link :to ="{name: createEmployeesName}" tag='div' class="fl" v-permission="'employee:saveEmployee'">
                <el-button type="primary" round icon=""><i class="iconfont icon-tianjia-copy "></i>创建员工账号</el-button>
              </router-link>
            </div>
          </div>
          <div class="tableBox">
            <el-table class="roleTable" :data="staffList" border v-loading="staffListLoading" >
              <el-table-column prop="employeeName" label="员工姓名" fixed></el-table-column>
              <el-table-column prop="userName" label="登录账号" min-width="150" fixed></el-table-column>
              <el-table-column prop="departmentName" label="部门"></el-table-column>
              <el-table-column prop="roleName" label="角色"></el-table-column>
              <el-table-column label="账号状态" v-if="checkPermission('employee:updateEmployeeStatus')">
                <template slot-scope="scope">
                  <el-switch @change="switchChange(scope.row.status,scope.row.id)" v-model="scope.row.status"></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="226">
                <template slot-scope="scope">
                  <div>
                    <el-button type="text" size="small" @click="editEmployee(scope.row.id)">编辑</el-button>
                    <el-button type="text" size="small" v-if="scope.row.status" @click="resetPassword(scope.row.id)">重置密码</el-button>
                    <el-button type="text" size="small" @click="getAccountList(scope.row.id,scope.row.employeeName,scope.row.departmentName)">查看投放账户</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="paging-box" v-if="pageTotal>0">
              <!-- <span class="page-total">显示全部项目{{pageTotal}}个项目</span> -->
              <el-pagination background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[ 10, 20, 40, 80, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next"
                :total="pageTotal">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 表单验证
import { notNullable, notNullableChange, passwordFormat } from '@/components/form/formValidation'

export default {
  name: 'staffManage',
  data () {
    // 重复密码验证
    const pwdAgainCheck = async (rule, value, callback) => {
      if (this.resetPasswordForm.password !== this.resetPasswordForm.repeatPassword) {
        return callback(new Error('两次输入密码不一致！'))
      } else {
        callback()
      }
    }
    return {
      nullShow: false,
      staffList: [],
      staffListLoading: true,
      departmentListTotal: 20,
      activeDepartmentId: '',
      departmentList: [],
      // 分页相关
      currentPage: 1, // 初始当前显示页
      pagesize: 10, // 初始每页的数据条数
      pageTotal: 0, // 数据总条数
      // 弹窗
      // 添加/修改部门
      opDepartmentType: '',
      opDepartmentid: '',
      opDepartmentParam: {},
      departmentPopupTitle: '',
      operateDepartmentVisible: false,
      teamList: [{
        id: 0,
        name: '默认'
      }, {
        id: 1,
        name: '优化团队'
      }, {
        id: 2,
        name: '创意团队'
      }],
      operateDepartmentForm: {
        name: '',
        team: 0
      },
      operateDepartmentRules: {
        name: [
          notNullable('请填写部门名称')
        ],
        team: [
          notNullableChange('请选择所属团队')
        ]
      },
      // 重置密码
      resetPasswordVisible: false,
      resetPasswordId: '',
      resetPasswordForm: {
        password: '',
        repeatPassword: ''
      },
      resetPasswordRules: {
        password: [
          notNullable('请填写新密码'),
          passwordFormat('密码')
        ],
        repeatPassword: [
          notNullable('请填写确认密码'),
          { required: true, validator: pwdAgainCheck, trigger: 'blur' }
        ]
      },
      // 查看投放账户
      viewAccountVisible: false,
      viewDeliveryAccount: {
        list: [],
        employeeName: '',
        departmentName: ''
      },
      // 编辑员工信息
      editEmployeeId: '',
      roleList: []
    }
  },
  created () {

  },
  mounted () {
    this.getPageData(this.$route.path)
  },
  watch: {
    // 监测弹窗
    operateDepartmentVisible (to, form) {
      if (to === false) {
        this.resetForm('operateDepartmentForm')
        this.operateDepartmentForm.name = ''
        this.operateDepartmentForm.team = 0
      }
    },
    resetPasswordVisible (to, form) {
      if (to === false) {
        this.resetForm('resetPasswordForm')
      }
    },
    $route (to) {
      this.getPageData(to.path)
    }
  },
  methods: {
    getPageData (routePath) {
      if (routePath === '/accountManage/staffManage' || routePath === '/qianchuan/account/staff') {
        this.getStaffList(this.currentPage, this.pagesize)
        this.getDepartmentList()
      } else {
        this.getDepartmentList('employees')
        this.getRoleList()
      }
    },
    // 获取角色列表
    getRoleList () {
      this.$service.get('/api/employee/getRoleList').then(res => {
        this.roleList = res.result
      }).catch(Err => {
      })
    },
    // 获取员工列表
    getStaffList (currentPage, pagesize, searchName) {
      this.$service.post('/api/employee/getEmployeeList', {
        'pageNum': currentPage,
        'pageSize': pagesize,
        'searchName': searchName
      }).then(res => {
        this.staffListLoading = false
        res.result.pageData.forEach((item, index) => {
          if (item.status === 1) {
            item.status = true
          } else {
            item.status = false
          }
        })
        this.staffList = res.result.pageData
        this.pageTotal = res.result.total
      }).catch(Err => {
        console.log(Err)
      })
      // this.staffList = [{
      //   name: '淘宝APP-01',
      //   account: 'aliqunqunsummer@sina.com',
      //   department: '产品部',
      //   role: '优化师',
      //   status: false,
      //   operating: '1'
      // }, {
      //   name: '淘宝APP-01',
      //   account: 'aliqunqunsummer@sina.com',
      //   department: '产品部',
      //   role: '优化师',
      //   status: true,
      //   operating: '1'
      // }, {
      //   name: '淘宝APP-01',
      //   account: 'aliqunqunsummer@sina.com',
      //   department: '产品部',
      //   role: '优化师',
      //   status: true,
      //   operating: '1'
      // }, {
      //   name: '淘宝APP-01',
      //   account: 'aliqunqunsummer@sina.com',
      //   department: '产品部',
      //   role: '优化师',
      //   status: true,
      //   operating: '1'
      // }, {
      //   name: '淘宝APP-01',
      //   account: 'aliqunqunsummer@sina.com',
      //   department: '产品部',
      //   role: '优化师',
      //   status: true,
      //   operating: '1'
      // }]
    },
    // 重置密码
    resetPassword (id) {
      this.resetPasswordId = id
      this.resetPasswordVisible = true
    },
    resetPasswordSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$service.post('/api/employee/resetPassword', {
            'id': this.resetPasswordId,
            'userPassword': this.$md5(this.resetPasswordForm.password + '')
          }).then(res => {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.resetPasswordVisible = false
          }).catch(Err => {

          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 编辑员工信息
    editEmployee (id) {
      this.editEmployeeId = id + ''
      if (this.$route.path.startsWith('/qianchuan')) {
        this.$router.push('/qianchuan/account/staff/modify')
      } else {
        this.$router.push('/accountManage/staffManage/modifyEmployees')
      }
    },
    // 查看投放账户
    getAccountList (id, name, departmentName) {
      this.viewDeliveryAccount.departmentName = departmentName
      this.viewDeliveryAccount.employeeName = name
      this.$service.post('/api/employee/getReferenceAccounts', {
        id: id,
        platformType: parseInt(localStorage.platformType)
      }).then(res => {
        this.viewDeliveryAccount.list = res.result
        this.viewAccountVisible = true
      }).catch(Err => {

      })
    },
    // 获取部门列表
    getDepartmentList (type) {
      // console.log(this.departmentList)
      this.$service.post('/api/employee/getDepartmentList').then(res => {
        this.departmentList = []
        if (type === 'employees') {
          this.departmentList = [{
            'departmentName': '请选择',
            'employeeAmount': res.result.totalEmployees,
            'id': ''
          }]
          // this.departmentList = res.result.list
        } else {
          this.departmentList = [{
            'departmentName': '全部',
            'employeeAmount': res.result.totalEmployees,
            'id': 0
          }]
        }
        res.result.list.forEach((item, index) => {
          this.departmentList[index + 1] = item
        })
      }).catch(Err => {
        console.log(Err)
      })
      // this.departmentList = [{
      //   title: '全部',
      //   num: '200',
      //   id: '1'
      // }, {
      //   title: '优化部',
      //   num: '123',
      //   id: '2'
      // }, {
      //   title: '运营一部',
      //   num: '1',
      //   id: '3'
      // }, {
      //   title: '运营二部',
      //   num: '3',
      //   id: '4'
      // }, {
      //   title: '设计一部',
      //   num: '5',
      //   id: '5'
      // }]
    },
    // 员工状态切换
    switchChange (to, id) {
      this.$service.post('/api/employee/updateEmployeeStatus', {
        'id': id,
        'status': to
      }).then(res => {
        this.$message({
          message: res.message,
          type: 'success'
        })
      }).catch(Err => {

      })
    },
    // 添加/编辑部门
    operateDepartment (type, item) {
      if (type === 'add') {
        this.departmentPopupTitle = '添加部门'
        this.opDepartmentType = 'add'
      } else if (type === 'edit') {
        this.departmentPopupTitle = '编辑部门'
        this.opDepartmentType = 'edit'
        this.opDepartmentid = item.id
        this.operateDepartmentForm.name = item.departmentName
        this.operateDepartmentForm.team = item.team
      }
      this.operateDepartmentVisible = true
    },
    operateDepartmenSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 参数
          if (this.opDepartmentType === 'add') {
            this.opDepartmentParam = {
              'departmentName': this.operateDepartmentForm.name,
              'team': this.operateDepartmentForm.team
            }
          } else if (this.opDepartmentType === 'edit') {
            this.opDepartmentParam = {
              'departmentName': this.operateDepartmentForm.name,
              'id': this.opDepartmentid,
              'team': this.operateDepartmentForm.team
            }
          }
          this.$service.post('/api/employee/addDepartment', this.opDepartmentParam).then(res => {
            // console.log(res)
            this.$message({
              message: res.message,
              type: 'success'
            })
            // 刷新列表
            this.getDepartmentList()
            this.getStaffList(this.currentPage, this.pagesize, this.activeDepartmentId)
            this.operateDepartmentVisible = false
          }).catch(Err => {
            console.log(Err)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 部门切换刷新员工列表
    changeDepartmentActive (id, name) {
      if (id === 0) {
        this.activeDepartmentId = ''
      } else {
        this.activeDepartmentId = id
      }
      console.log(id)
      this.getStaffList(this.currentPage, this.pagesize, this.activeDepartmentId)
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.pagesize = size
      this.getStaffList(this.currentPage, size)
    },
    // 切换分页
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getStaffList(currentPage, this.pagesize)
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  computed: {
    createEmployeesName() {
      return this.$route.path.startsWith('/qianchuan') ? 'qccreateEmployees' : 'createEmployees'
    }
  }
}
</script>

<style lang='less'>
@import './../../styles/accountManage/staffManage.less';
</style>



// WEBPACK FOOTER //
// src/views/accountManage/staffManage.vue